<div class="tw-mx-4 tw-mt-3 tw-pb-3 tw-rounded-3 tw-overflow-visible" [class]="isHairRegimen ? 'tw-bg-purple-75' : 'tw-bg-yellow-75'">
  <div class="tw-flex tw-items-start tw-gap-2">
    <div class="tw-pl-4 tw-mt-2 xxs:tw-mt-5 tw-flex-[3_0_calc(52%-4px)]">
      @if (reorderKit()?.regimenClass?.toLowerCase() === ApiClientConstant.Regimen.Class.FACE.toLowerCase()) {
        <p class="tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@yourCompleteSkinKit">Your complete skin kit</p>
      }
      @if (reorderKit()?.regimenClass?.toLowerCase() === ApiClientConstant.Regimen.Class.HAIR.toLowerCase()) {
        <p class="tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@yourCompleteHairKit">Your complete hair kit</p>
      }
      <p class="tw-font-body tw-text-200 tw-text-gray-800 tw-mt-1" i18n="@@includesProducts"> Includes {{reorderKit()?.products?.length}} products </p>
    </div>
    <div class="tw-flex-[2_0_calc(48%-4px)] tw-flex tw-items-end tw-z-50">
      <img class="tw-w-full tw-h-full tw-object-contain" [src]="kitImage()" alt="doctor holding kit" />
    </div>
  </div>
  <div class="tw-bg-white tw-rounded-3 tw-mx-2 tw-p-4 -tw-mt-6 tw-relative tw-z-10">
    @for (product of reorderKit()?.products ?? []; track product.objectId) {
      <div class="tw-flex tw-items-center tw-gap-[6px] tw-my-2 first:tw-mt-0 last:tw-mb-0">
        <cs-icon class="tw-w-4 tw-h-4 tw-text-green-500" [iconName]="'green_tick_circle'"></cs-icon>
        <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-600">
          {{product.title}} - {{product.quantity}} {{product.quantityUnit}}
        </p>
      </div>
    }
  </div>
  @if (showDoctorCharges()) {
    <div class="tw-flex tw-items-center tw-justify-center tw-my-1">
      <span class="tw-text-300 tw-font-body tw-text-gray-600">+</span>
    </div>
    <div class="tw-mx-2 tw-px-3 tw-py-4 tw-border tw-border-dashed tw-border-orange-500 tw-rounded-3">
      <p class="tw-text-300 tw-font-lexend tw-font-bold tw-text-gray-800" i18n="@@2MonthlyDoctorCheckups">2 Monthly Doctor Check-ups</p>
    </div>
  }
</div>
